import React from 'react';
import { FiXCircle } from 'react-icons/fi';
import styled from 'styled-components';
import { colors, Regular } from './Styles';

type Props = {
  /** title of the tag */
  title: string;
  /** on x press */
  onPressX?: () => void;
  /** mode of the tag */
  editable?: boolean;
  type?: 'default' | 'block';
  className?: string;
};

export const RhTag: React.FC<Props> = props => {
  const { editable = true } = props;
  return (
    <Container $isBlock={props.type === 'block'} className={props.className}>
      <Regular
        style={{
          maxWidth: 150,
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        }}
        color={colors.primary}
        weight="bold">
        {props.title}
      </Regular>
      {editable ? (
        <FiXCircle
          style={{ cursor: 'pointer' }}
          onClick={props.onPressX}
          size={18}
          fill={colors.primary}
          color="#fff"
        />
      ) : (
        <div />
      )}
    </Container>
  );
};

const Container = styled.div<{ $isBlock: boolean }>`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  padding: 8.5px;
  background: ${p => (p.$isBlock ? colors.secondary : '#fff')};
  border: 1px solid ${colors.primary};
  border-radius: 52px;
  & > :first-child {
    margin-left: 10px;
  }
  & > :not(:last-child) {
    margin-right: 8px;
  }
`;
